import * as React from "react";

export const useHideBanner = () => {
  React.useEffect(() => {
    hideBanner();
    return () => {
      unhideBanner();
    };
  }, []);
  const hideBanner = () => {
    const bodyElement = document.querySelector("body");
    if (bodyElement) {
      bodyElement.classList.add("bbnt-plp-page-no-search-results");
    }
  };
  const unhideBanner = () => {
    const bodyElement = document.querySelector("body");
    if (bodyElement) {
      bodyElement.classList.remove("bbnt-plp-page-no-search-results");
    }
  };
};
